import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'; // switch to `react-router-dom` if using React Router

export default function useSearchParams() {
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );

  const searchParamsRef = useRef(searchParams);

  useEffect(() => {
    searchParamsRef.current = searchParams;
  }, [searchParams]);

  const setSearchParams = useCallback(
    (setter) => {
      const newParams =
        typeof setter === 'function' ? setter(searchParamsRef.current) : setter;
      navigate(`?${newParams}`);
    },
    [navigate],
  );

  return [searchParams, setSearchParams];
}
